module.exports = __webpack_public_path__ + "assets/img/bg-line-mecha-074fd157.png";